import React from 'react';
import styled from 'styled-components';
import { borders, spaces, typography } from '../../settings';
import { Box } from '../Box';
import { IconX1 } from '@99designs/icons';

// FIXME This needs to be consolidated with other IconButton implementations and moved into the UI library.  This is
// only here for now to remove a dependency on the microfrontend version.
const IconButton = styled.button`
    color: currentColor;
    background: transparent;
    border: 0;
    padding: 0;
    cursor: pointer;
    text-align: center;
    display: inline;
    position: relative;
    z-index: 0;
    overflow: visible;

    &:hover,
    &:focus,
    &:active {
        text-decoration: none;
        outline: none;

        &:before {
            content: '';
            display: block;
            position: absolute;
            z-index: -1;
            transform: translate(-50%, -50%);
            top: 50%;
            left: 50%;
            width: 2em;
            height: 2em;
            border-radius: 50%;
        }
    }
`;

export interface BaseAlertProps {
    icon?: React.ReactNode;
    className?: string;
    children: React.ReactNode;
    onDismiss?: () => void;
    dismissed?: boolean;
}

export function BaseAlert({
    className,
    children,
    icon,
    onDismiss,
    dismissed = false,
}: BaseAlertProps) {
    const hide = () => {
        if (onDismiss) {
            onDismiss();
        }
    };

    if (dismissed) return null;

    return (
        <Box
            display="flex"
            css={`
                padding: ${spaces.space6}px ${spaces.halfGutter}px;
                border-radius: ${borders.borderRadiuses.medium}px;
            `}
            className={className}
            data-testid={'BaseAlert'}
        >
            <Box marginRight="space6">{icon}</Box>
            <div
                css={`
                    line-height: ${typography.lineHeights.root};
                    font-size: ${typography.fontSizes.root}px;
                    margin: 0;
                    flex-grow: 1;
                `}
            >
                {children}
            </div>
            {onDismiss && (
                <Box marginLeft="space6">
                    <IconButton aria-label={__('Dismiss')} onClick={hide}>
                        <IconX1 />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}
